<mat-card-actions align="end">
  <div fxLayout="row">
    <div *ngIf="allDemandsAndFilter" class="select-state">
      <mat-form-field>
        <mat-select placeholder="Filtrer sur une étape particulière"
                    matTooltip="Filtrer sur une étape particulière"
                    [value]="statusLabelSelected"
                    (selectionChange)="onStateFiltered($event)">
          <mat-option [value]="null"><< Toute étape >></mat-option>
          <mat-option *ngFor="let st of statusLabels" [value]="st">
            <span ngClass="{{getClassFromType(st.id)}}">{{ st.label }}</span>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="check-all-dossiers">
      <mat-checkbox
        matTooltip="cliquer pour voir tous les dossiers, toute étape confondue"
        [checked]="allDemandsAndFilter"
        (change)="onChangedAllCases($event)"
        style="font-size: 0.8rem; font-weight: 500;">Tous les dossiers / filtrer sur une étape
      </mat-checkbox>
    </div>
  </div>
</mat-card-actions>
